<div class="user_menu_section">
  <div class="user_menu_block">
    <div class="user_menu_item" *ngFor="let data of menuData; let i = index">
      <span style="width: max-content" [routerLink]="data.routerLink"
      routerLinkActive="common_big_span_bold active_account_item">{{localize.language[data.title]}}</span>
    </div>
  </div>
</div>
